import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form';
import {
  retrieveInitiativeCategories,
  selectInitiativeCategoriesWithArchived,
} from '../../../modules/initiativeCategories.js';
import FieldGroup from '../../FieldGroup.jsx';
import Empty from '../../Empty.jsx';

const mapStateToProps = (state) => ({
  initiativeCategories: selectInitiativeCategoriesWithArchived(state),
});

const mapDispatchToProps = { retrieveInitiativeCategories };

const CategorySelect = ({
  initiativeCategories,
  initiativeType,
  retrieveInitiativeCategories,
  initiativeSelectedCategory,
}) => {
  useEffect(() => {
    retrieveInitiativeCategories(initiativeType);
  }, []);

  const categoriesFilteredByType = initiativeCategories.filter(
    (category) => category.initiativeType === initiativeType
  );

  const selectedCategory = categoriesFilteredByType.find(
    (item) => item.id === initiativeSelectedCategory
  );

  const isSelectedArchived = selectedCategory?.archived;

  const categoriesFilteredByArchivedStatus = (arr) =>
    arr.filter((category) => !category.archived);

  const initiativeArchivedCategory = (arr) =>
    isSelectedArchived ? [...arr, selectedCategory] : arr;

  const categoriesSortedByName = (arr) =>
    arr.sort((a, b) => a.name.localeCompare(b.name));

  const findOtherParam = (arr) => arr.find((item) => item.name === 'Other');
  const moveOtherParam = (arr) =>
    findOtherParam(arr)
      ? [...arr.filter((item) => item.name !== 'Other'), findOtherParam(arr)]
      : arr;

  return initiativeCategories ? (
    <Field
      id="initiativeFormCategory"
      name="category"
      label="Category"
      componentClass="select"
      customClass="m-b-12"
      component={FieldGroup}
    >
      <option value="" disabled>
        - Select a Category -
      </option>
      {moveOtherParam(
        categoriesSortedByName(
          initiativeArchivedCategory(
            categoriesFilteredByArchivedStatus(categoriesFilteredByType)
          )
        )
      ).map((category) => (
        <option
          key={`${category.id}${category.initiative_type}`}
          value={category.id}
        >
          {category.name}
        </option>
      ))}
    </Field>
  ) : (
    <Empty simplified />
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CategorySelect);
